module.exports = __webpack_public_path__ + "static/media/invite-2.0e1965be.jpeg";